import React, { useState, useEffect, useRef } from 'react';
import { LandingHeaderB2B } from './LandingHeaderB2B';
import { Footer } from '../footer/Footer';
import { Link } from 'react-router-dom';
import WebChatZoomCrm from '../../assets/zoom-messenger-react/lib/addBubble.js';
const landingImages = require.context('../../assets/images', true);

export const LandingHomePage = () => {
  const [alturaIframe, setAlturaIframe] = useState(window.innerHeight);
  const targetRef = useRef(null);
  const headerHeight = 200;
  const secondSectionRef = useRef(null);

  useEffect(() => {
    const ajustarAlturaIframe = () => {
      setAlturaIframe(window.innerHeight);
    };
    window.addEventListener('resize', ajustarAlturaIframe);
    return () => {
      window.removeEventListener('resize', ajustarAlturaIframe);
    };
  }, []);

  /*useEffect(() => {
    const updatePageHeight = () => {
      const newPageHeight = window.innerHeight;
      setPageHeight(newPageHeight);
      setDoublePageHeight(newPageHeight * 2);
    };

    window.addEventListener('resize', updatePageHeight);
    updatePageHeight();

    return () => {
      window.removeEventListener('resize', updatePageHeight);
    };
  }, []);*/

  const handleLinkClick = () => {
    if (secondSectionRef.current) {
      const rect = secondSectionRef.current.getBoundingClientRect();
      const yOffset = rect.top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  };
  return (
    <>
      <LandingHeaderB2B />
      <div id="contWebChatZoomCrm">
        <WebChatZoomCrm
          elementId="contWebChatZoomCrm"
          backgroundColor="#3BAC53"
          color="#FFFFFF"
          socialGatewayUrl="https://socialgateway.verzia.io/modules/zoomWebChat/zoomMessengerLog.php?params=N3hMWEdVWndFVytYQnE4cU4xSm1pMlhRaHVvSXVPRmVuNjQrdGFvS0o4cTZaOSt2eFEyNmhoM1Y3TDk1MWNXZFhUbld3YXlEOUdEUlliTUVvYkFkVGEvMHJlNS9pQVFyTXc1MTVOZGNPRW9LN0VsZFNwdFllRFBCVzhrYm1HZ1YyeXFDVE9TUlZYdTBuUE9TbnVaTHM2RkNJVGErSGNDTTFvek5EeXNuc3dhOTJ6RG1TcXdGSmV2eFMwbEJZSmtuUzA0M2cxQ2c5cEpwV1Y2Z1pGZ3lmZ3JHeVp0cFdxTk5UaWZVSStQMmZYR2gxWXVwV2tUWithQzFxTnIwSzFTZmdtenNva0U5NHlaM3pxY3RJVkFQUnl6d1N4MHJONFplem1EN3o5dGc3VUkrR0U3Z05BekE0V2NKNW9NRjl3dldVMUYyUnRYV05yeFk0Q2dDR1VtTDdRd1FtL1BkVUp5U01obktRN2lSeThuWWJaZmtMTkUrcjgyVFFJMFFCM1NKM1p4ckNOUW5sTy9LYWFWbWhqYTJYQWtXTEVjbXoyNDRFd2s1OXNsTlI2R0VuNmVNdHhEbE1hQVdRTER0Wk5rcnVkU0g3Wk9TNmc3QkJRUlRkTnJDbHA2ZXpvVW5SbkFjMlFFK2xLUmhVUHRPQU83S0xmOWd6elkvZ01XeTdqM1BoaDIwQzFEMk12N2pUZitJNFMwYkdFcWUweHJyeFlNSUwxWkhMUXFxMlpCRUpUZFY3dGpsazdBcEtoRS9OdjlrdnphUDcrTnNWQ0xXQWJRWjBMTXlBQmJuekxleFZDbzBWcDkyUzU2dks5b0NxT3l0Vk4xRk5Majlldytqcy9hbk1nSndTVVBRRXlZQlVuMitsYkNpVGtTaVhRdElaa0VyVDMvc3pNSjRvUUdnUlpOdVV5NWpsOUJJSjhnY0hQbC80Z2s5YjE3akZraHVwZ0EzZitFdFIzSEloTERJM0ozSUlua3RZMTNQdm02ZERVM0ZUdjBsaUVLTjk0SGxEN2Y2KzRjWDNXS2tqakVlWGhlRmdxY1Z0WnNWSVhJVjdTclljV09QaUFQbWxsSE1xWldoUzdlN3BGSWtqb0dJV0l5cmFnNnFqNEtWc3VuRnhmNmhsY1FTa1NINGZNYlJBYkdSU2pZZlpKM3d4S1R3MUZrQkpRbVJyVG00SWFYS1RvVzNmOWNTbHF4WWNXWGRZVmV0QXZ5M3V6d1B5TkdpbXhORXJjTUdoWDRQWmo1Z1RxcWxGTzFNNWt4RWZQakh3QzNNcm9GU0hXcGNldDkwR01CbGhmMHlXQ09pck1oT3o4S1NrVkw1U1dNQUY0aURuampZMHBrdldBN0xHUlNmeSt1M0hNbm1iNXV4REh4bWJ3R1VSWFZFaXhnR0ZwQVV5MWhadFZTV1htelFZYjdzR3Y4VE5OY2svQjNMZjdHY0h0MGFCR2lSdEF1TkhmQ2lSZFBDV2VMczQ3ZXU1N1FzZzA5RmxDd21JV3R1WkE1WWJIclFCamJNKytuNVhNeE1TempUTXEzY1lYY0QxSzBmQ01GZnp5bHhna0lrYVB3Y1BVTW11TU45TUxRLzczYz0="
        />
      </div>
      <div className="container-fluid landing__HomeSection">
        <div className="container my-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-xl-5 col-lg-5 col-md-10 col-12">
              <div className="row">
                <div className="col-12 landing__title-top-banner">
                  TRANSFORMANDO JÓVENES EN EMPRENDEDORES SOSTENIBLES
                </div>
              </div>
              <div className="row my-3">
                <div className="col-12 landingb2b__paragraph-text mb-2">
                  Una iniciativa única que busca desarrollar
                  <br /> habilidades emprendedoras en adolescentes
                  <br /> de 14 a 17 años.
                  <span className="fw-bold">
                    {' '}
                    ¡Totalmente GRATIS para hijos de docentes o colaboradores de la Universidad Ean!
                  </span>
                </div>
              </div>
              <div className="mb-3">
                <Link to="/contacto" className="landingb2b__button-primary">
                  INSCRÍBETE AQUÍ
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex pe-0 d-lg-grid">
              <img
                alt="Cursos digitales que se adaptan a tu empresa"
                src={landingImages('./ImageBannerHome.png')}
                className="img-fluid"
                width="90%"
                height="80%"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="contenedor">
        <div className="landing__circle">
          <Link to="#!" onClick={handleLinkClick}>
            <i className="fa-solid fa-chevron-down landing_chevron"></i>
          </Link>
        </div>
      </div>

      <div className="container-fluid landing__HomeServicesSection">
        <div className="row justify-content-center text-center">
          <div className="col-9 col-md-7 mb-4">
            <p className="landing__h3" ref={secondSectionRef}>
              ¿QUÉ ES &quot;YO EMPRENDO&rdquo;?
            </p>
            <p className="landingb2b__paragraph-text">
              Un programa estructurado en 3 etapas clave, que prepara a los jóvenes para ser agentes
              de cambio económico y social con enfoque en sostenibilidad.
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid d-flex justify-content-center landing__bgservices">
        <div className="container">
          <div className="row">
            <div className="col-12 p-5 mt-3 pt-4">
              <div className="row justify-content-center text-center">
                <div className="col-12 col-md-4 col-lg-3 px-3">
                  <img
                    className="landingb2b__servicios-demob2b"
                    alt="Formación a la medida"
                    src={landingImages('./descubrir.png')}
                    width="150"
                    height="100"
                  />
                  <p className="landing__title-servicios">DESCUBRIR</p>
                  <p className="landingb2b__paragraph">
                    Explorar habilidades emprendedoras y reconocer problemas significativos.
                  </p>
                </div>
                <div className="col-12 col-md-4 col-lg-3 px-3">
                  <img
                    className="landingb2b__servicios-demob2b"
                    alt="Proveedor de contenidos"
                    src={landingImages('./comprender.png')}
                    width="170"
                    height="150"
                  />
                  <p className="landing__title-servicios">COMPRENDER</p>
                  <p className="landingb2b__paragraph">
                    Diseñar soluciones centradas en el cliente y prototipar ideas.
                  </p>
                </div>
                <div className="col-12 col-md-4 col-lg-3 px-3">
                  <img
                    className="landingb2b__servicios-demob2b"
                    alt="Licencias"
                    src={landingImages('./crear.png')}
                    width="150"
                    height="150"
                  />
                  <p className="landing__title-servicios">CREAR</p>
                  <p className="landingb2b__paragraph">
                    Desarrollar un producto mínimo viable, estrategia de marca y comercial.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid landing__HomeServicesSection">
        <div className="row justify-content-center text-center">
          <div className="col-12 mb-4">
            <p className="landing__h3">¿QUÉ NOS HACE LA MEJOR OPCIÓN?</p>
          </div>
        </div>
      </div>
      <div className="container-fluid mx-0 px-0">
        <div className="justify-content-center text-center">
          <iframe
            width="100%"
            height={alturaIframe}
            src="https://www.youtube.com/embed/8Bozs2dTYHc?si=LOajhE0FkdZmJG6Z"
            title="YouTube video player"
            frameBorder="0"
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
      <div className="container-fluid landing__HomeServicesSection">
        <div className="row justify-content-center text-center">
          <div className="col-12 mb-4">
            <p className="landing__h3">¿CÓMO SE COMPONE EL PROGRAMA?</p>
          </div>
        </div>
      </div>
      <div className="container-fluid d-flex justify-content-center">
        <div className="col-10">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-12 col-sm-6 col-lg-5 mb-3 mt-2">
                <div className="text-center">
                  <div className="text-center mx-auto text-conoce-eanx">
                    <img
                      className="landingb2b__servicios-demob2b"
                      alt="Duración de 9 meses"
                      src={landingImages('./duracion.png')}
                      width="150"
                      height="100"
                    />
                  </div>
                  <div className="text-center mx-auto title-two-program">
                    Duración de <br />9 meses
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-5 mb-3 mt-2">
                <div className="text-center">
                  <div className="text-center mx-auto text-conoce-eanx">
                    <img
                      className="landingb2b__servicios-demob2b"
                      alt="Cápsulas EanX"
                      src={landingImages('./capsulas-x.png')}
                      width="150"
                      height="100"
                    />
                  </div>
                  <div className="text-center mx-auto title-two-program">
                    Cápsulas
                    <br />
                    EanX
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3 mt-2">
                <div ref={targetRef} className="text-center">
                  <div className="text-center mx-auto text-conoce-eanx">
                    <img
                      className="landingb2b__servicios-demob2b"
                      alt="Guías Didácticas"
                      src={landingImages('./guias-didacticas.png')}
                      width="150"
                      height="100"
                    />
                  </div>
                  <div className="text-center mx-auto title-two-program">
                    Guías
                    <br />
                    Didácticas
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3 mt-2">
                <div className="text-center">
                  <div className="text-center mx-auto text-conoce-eanx">
                    <img
                      className="landingb2b__servicios-demob2b"
                      alt="Drops de contenido"
                      src={landingImages('./drops-contenido.png')}
                      width="150"
                      height="100"
                    />
                  </div>
                  <div className="text-center mx-auto title-two-program">
                    Drops de
                    <br />
                    contenido
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3 mt-2">
                <div className="text-center">
                  <div className="text-center mx-auto title-one-program">
                    <img
                      className="landingb2b__servicios-demob2b"
                      alt="Guías Didácticas"
                      src={landingImages('./cupos-limitados.png')}
                      width="150"
                      height="100"
                    />
                  </div>
                  <div className="text-center mx-auto title-two-program">
                    Cupos
                    <br />
                    limitados
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid landing__ParticiparSection">
        <div className="container my-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-3 text-center mb-3">
              <img
                alt="Cursos digitales que se adaptan a tu empresa"
                src={landingImages('./como-participar.png')}
                className="img-fluid"
                width="300"
                height="80%"
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-6">
              <div className="row">
                <div className="col-12 landing__title-participar text-center">
                  ¿CÓMO PARTICIPAR?
                </div>
              </div>
              <div className="row my-3">
                <div className="col-12 landingb2b__paragraph-participar mb-2 text-center">
                  En EanX estamos por lanzar este nuevo
                  <br />
                  método de aprendizaje y queremos que los
                  <br />
                  hijos de los docentes y colaboradores de la
                  <br />
                  Universidad Ean sean los primeros en
                  <br />
                  probarlo, ¡sin ningún costo!{' '}
                  <span className="fw-text-bold">Cupos limitados.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid landing__InscriptionSection">
        <div className="container my-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6">
              <div className="row">
                <img
                  alt="#demob2b"
                  src={landingImages('./hasyoemprendo.png')}
                  className="img-fluid"
                  width="100"
                  height="100%"
                />
              </div>
              <div className="mt-5 mb-3 d-none d-md-block">
                <Link to="/contacto" className="landingb2b__button-primary-bt">
                  INSCRÍBETE AQUÍ
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 text-center">
              <img
                alt="Cursos digitales que se adaptan a tu empresa"
                src={landingImages('./inscripcion.png')}
                className="img-fluid"
                width="300"
                height="80%"
              />
            </div>
            <div className="mt-5 mb-3 text-center d-block d-md-none">
              <Link to="/contacto" className="landingb2b__button-primary-bt">
                INSCRÍBETE AQUÍ
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
